import React from 'react';
import { Sparkles, Search, MessageCircle, Layers, CheckCircle } from 'lucide-react';
import { fiveEs } from '../../data/mock';

const iconMap = {
  Sparkles,
  Search,
  MessageCircle,
  Layers,
  CheckCircle
};

const FiveEsSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-64 h-64 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-64 h-64 bg-teal-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-white/10 text-blue-300 text-sm font-semibold rounded-full mb-4 backdrop-blur-sm border border-white/20">
            Our Methodology
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Pathways to a Purposeful Future
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Our proven 5E&apos;s methodology ensures deep understanding and practical application 
            of STEAM concepts.
          </p>
        </div>

        {/* 5E's Path */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-teal-500 to-cyan-500 transform -translate-y-1/2 rounded-full"></div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            {fiveEs.map((item, index) => {
              const IconComponent = iconMap[item.icon];
              return (
                <div
                  key={item.id}
                  className="relative group"
                >
                  <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:transform hover:-translate-y-2">
                    {/* Step Number */}
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg z-10">
                      {index + 1}
                    </div>

                    <div className="text-center pt-4">
                      <div className="w-16 h-16 mx-auto bg-gradient-to-br from-blue-500/30 to-teal-500/30 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                        <IconComponent className="w-8 h-8 text-teal-400" />
                      </div>

                      <div className="text-3xl font-bold text-blue-400 mb-1">{item.letter}</div>
                      <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
                      <p className="text-gray-300 text-sm leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FiveEsSection;
